const camelToSnakeCase = str =>
    str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export default camelToSnakeCase;
